'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$6() {
  this.aBs = null;
  this.aBt = false;
}
export { $c_Lpresto_AuditView$$anon$6 as $c_Lpresto_AuditView$$anon$6 };
$p = $c_Lpresto_AuditView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$6;
/** @constructor */
function $h_Lpresto_AuditView$$anon$6() {
}
export { $h_Lpresto_AuditView$$anon$6 as $h_Lpresto_AuditView$$anon$6 };
$h_Lpresto_AuditView$$anon$6.prototype = $p;
$p.P = (function() {
  if ((!this.aBt)) {
    this.aBs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aBt = true;
  }
  return this.aBs;
});
var $d_Lpresto_AuditView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$6, "presto.AuditView$$anon$6", ({
  EA: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AuditView$$anon$6 as $d_Lpresto_AuditView$$anon$6 };
//# sourceMappingURL=presto.-Audit-View$$anon$6.js.map
